import React from "react";
import { Breadcrumbs, Typography, Link } from "@mui/material";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import useTranslate from "hooks/use-translate-language";

const BreadCrumbs = ({
  parentLink,
  parentLinkLabel,
  childLabel,
  title,
  titleClassname,
  thirdBreadcrumb
}) => {
  const translate = useTranslate();

  return (
    <div>
      <nav aria-label="Breadcrumb">
        <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />}>
          <Typography underline="hover" color="inherit">
            {translate(parentLinkLabel)}
          </Typography>

          <Typography
            sx={thirdBreadcrumb ? {} : { color: "text.primary" }}
            aria-current={thirdBreadcrumb ? undefined : "page"}
          >
            {translate(childLabel)}
          </Typography>

          {thirdBreadcrumb && (
            <Typography sx={{ color: "text.primary" }} aria-current="page">
              {translate(thirdBreadcrumb)}
            </Typography>
          )}
        </Breadcrumbs>
      </nav>
      <h1
        className={titleClassname ? titleClassname : "profile-actions-label"}
        style={{ marginTop: "0px" }}
        tabIndex={0}
        aria-label={title}
      >
        {translate(title)}
      </h1>
    </div>
  );
};

export default BreadCrumbs;
